export const prospectAudit = {
  title: 'Prospect audits',
  subtitle: 'Audits automatically triggered by the Supabase landing-page form.',
  empty: 'No prospect submissions yet.',
  loading: 'Loading prospects…',
  searchPlaceholder: 'Search by email or URL',
  searchLabel: 'Search prospect submissions',
  columns: {
    email: 'Email',
    url: 'URL',
    referralSource: 'Source',
    status: 'Status',
    submittedAt: 'Received',
    auditStatus: 'Audit status',
  },
  status: {
    received: 'Queued',
    started: 'Dispatched',
    failed: 'Failed',
    deduplicated: 'Duplicate',
  },
  auditStatus: {
    pending: 'Pending',
    crawling: 'Crawling',
    processing: 'Processing',
    analyzing_geo: 'Analyzing GEO',
    analyzing_presence: 'Analyzing presence',
    awaiting_confirmation: 'Awaiting confirmation',
    analyzing_presence_targeted: 'Analyzing competitors',
    generating_report: 'Generating report',
    completed: 'Completed',
    failed: 'Failed',
  },
  pagination: {
    prev: 'Previous page',
    next: 'Next page',
    pageOf: 'Page {{page}} of {{total}}',
  },
} as const
